/**
 * External dependencies
 */
import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';

/**
 * Internal dependencies
 */
import { ProjectList, Projects, ProjectListCondition, ProjectInfo, ProjectInfos } from './types';

class Project extends Immerable {
  public projectListDefaultCondition: ProjectListCondition;

  public projectList: Projects;

  public projectInfos: ProjectInfos;

  public constructor() {
    super();
    this.projectListDefaultCondition = {
      api: {
        page: 1,
        page_size: 40,
        with_pager: true
      },
      display: {
        keyword: ''
      }
    };
    this.projectList = {
      condition: this.projectListDefaultCondition,
      content: {
        list: []
      }
    };
    this.projectInfos = {};
  }

  public initialize(): void {
    this.projectListDefaultCondition = {
      api: {
        page: 1,
        page_size: 40,
        with_pager: true
      },
      display: {
        keyword: ''
      }
    };
    this.projectList = {
      condition: this.projectListDefaultCondition,
      content: {
        list: []
      }
    };
    this.projectInfos = {};
  }

  public updateProjectList(newList: ProjectList, newCondition: ProjectListCondition): void {
    this.projectList = { content: newList, condition: newCondition };
  }

  public updateProjectInfo(newProjectID: string, newProject: ProjectInfo): void {
    this.projectInfos[newProjectID] = newProject;
  }
}

export default Project;
